// extracted by mini-css-extract-plugin
export var legend = "Legend_legend__3asbq";
export var legendHero = "Legend_legendHero__0kU7z";
export var legendPhoto = "Legend_legendPhoto__rhV1M";
export var legendPhotoWrapper = "Legend_legendPhotoWrapper__dLBDH";
export var legendInfo = "Legend_legendInfo__l56Yn";
export var items = "Legend_items__wgfSP";
export var rotate = "Legend_rotate__nxglH";
export var dotty = "Legend_dotty__TCIH9";